import React from 'react';
import { useStyles } from './GoBack.styles';
import { Link } from 'react-router-dom';
import ArrowLeft from '@mui/icons-material/KeyboardArrowLeftRounded';
import { Box } from '@mui/material';
export const GoBack = (props) => {
    const classes = useStyles();
    const Content = () => (React.createElement(Box, { component: "div", sx: classes.container },
        React.createElement(ArrowLeft, null)));
    // TODO: Kolla om detta funkar sen
    const AsLink = React.forwardRef((linkProps, ref) => (React.createElement(Link, Object.assign({ to: props.to, ref: ref, style: classes.root }, linkProps),
        React.createElement(Content, null))));
    return React.createElement(AsLink, Object.assign({}, props));
};
export default GoBack;
